import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULTS = {
  title: "Maxine Consulting OPC Private Limited — ERP, software & cloud that ship",
  description: "Regional ERP suite for manufacturing, healthcare, retail and logistics — plus fixed-price web, cloud hosting and growth marketing across UAE, EU and India. 12 industry-tuned ERP products, deployed in 30 days.",
  image: "/og-cover.png?v=blue2",
};

export default function SEO({ title, description, image, path }) {
  const t = title ? `${title} · Maxine Consulting` : DEFAULTS.title;
  const d = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const url = typeof window !== "undefined" ? `${window.location.origin}${path || window.location.pathname}` : "";
  const fullImg = img?.startsWith("http") ? img : (typeof window !== "undefined" ? `${window.location.origin}${img}` : img);

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={fullImg} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={fullImg} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
